import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import packageJson from '../../../../../package.json'


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  @Input({ required: true })
  backendVersion: string
  @Input()
  logoUrl: string
  version = packageJson.version

}
